<div *ngIf="cardInfo() as cardInfo">
  <mat-card class="bottom-card">
    <mat-card-header [style.margin-left]="!showAvatar() ? (AVATAR_WIDTH + 16).toString() + 'px' : null">
      <div matCardAvatar *ngIf="showAvatar()">
        <glxy-avatar
          [width]="AVATAR_WIDTH"
          icon="call"
          backgroundColor="var(--primary-background-color)"
          textColor="#9E9E9E"
        ></glxy-avatar>
      </div>
      <mat-card-title>
        <span *ngIf="headerText() as headerText; else unknown" class="title">{{ headerText }}</span>
        <ng-template #unknown>
          <span class="title">{{ 'ACTIVITY.UNKNOWN_TITLE' | translate }}</span>
        </ng-template>
      </mat-card-title>
      <mat-card-subtitle>
        <p *ngIf="cardInfo.date !== null" class="effective-date">
          {{ cardInfo.date | date: dateFormat }}
        </p>
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content [style.margin-left]="(AVATAR_WIDTH + 16).toString() + 'px'">
      <mat-card appearance="outlined" class="inner-card">
        <mat-card-title class="mat-card-title">
          <span *ngIf="cardTitle() as cardTitle" class="title">{{ cardTitle }}</span>
        </mat-card-title>
        <mat-card-content>
          <div class="subtitle">
            @if (cardInfo.direction === 'Inbound') {
              <span>
                @if (this.associatedCrmObject(); as associatedObject) {
                  <div>
                    {{ associatedObject }}
                    @if (cardInfo.from) {
                      <span>({{ cardInfo.from }})</span>
                    }
                  </div>
                  <div>
                    to {{ ownerName() }}
                    @if (cardInfo.to) {
                      <span>({{ cardInfo.to }})</span>
                    }
                  </div>
                }
              </span>
            } @else {
              <span>
                <div>
                  {{ ownerName() }}
                  @if (cardInfo.to) {
                    <span>({{ cardInfo.to }})</span>
                  }
                </div>
                @if (this.associatedCrmObject(); as associatedObject) {
                  <div>
                    to {{ associatedObject }}
                    @if (cardInfo.from) {
                      <span>({{ cardInfo.from }})</span>
                    }
                  </div>
                }
              </span>
            }
          </div>
          <div>
            @if (cardInfo.body) {
              <crm-collapsible-section [maxHeightPx]="100">
                <span class="call-body" [innerHTML]="cardInfo.body | iTrustThisHtml"></span>
              </crm-collapsible-section>
            }
          </div>
          <ng-container *ngIf="callRecordingSource$ | async as callUrl">
            <audio class="activity-data-call-recording" preload="metadata" controls src="{{ callUrl }}">
              {{ 'ACTIVITY.AUDIO_PLAYBACK_ERROR' | translate }}
            </audio>
          </ng-container>
          @if (cardInfo.transcriptJSON) {
            <a data-action="”view-transcript-clicked”" (click)="openTranscriptModal()">{{
              'ACTIVITY.CALL.VIEW_TRANSCRIPT' | translate
            }}</a>
          }
        </mat-card-content>
      </mat-card>
    </mat-card-content>
  </mat-card>
</div>
